
import {
    TouchableOpacity,
    Image,
    View
} from "react-native";
import {
    type AnnouncementCardProps,
} from "./types";
import stylesheet from "./stylesheet";
import {
    NCoreUIKitTheme,
    Text
} from "ncore-ui-kit";
import {
    useDebouncedDimensions
} from "../../utils";
import {
    ArrowUpRight
} from "lucide-react-native";
import Linear2 from "../../assets/images/linear.png";

const AnnouncementCard = ({
    coverPhotoURL,
    content,
    disabled,
    onPress,
    title
}: AnnouncementCardProps) => {
    const {
        windowWidth
    } = useDebouncedDimensions();

    const {
        radiuses,
        colors,
        spaces,
        borders
    } = NCoreUIKitTheme.useContext();

    return <TouchableOpacity
        onPress={onPress}
        disabled={disabled}
        style={[
            stylesheet.container,
            {
                width: windowWidth * 0.85,
                height: (windowWidth * 0.85) * 1.25,
                borderRadius: radiuses.xl
            }
        ]}
    >
        <Image
            source={{
                uri: coverPhotoURL
            }}
            resizeMode="cover"
            style={[
                stylesheet.image,
                {
                    borderColor: colors.content.border.subtle,
                    borderRadius: radiuses.xl,
                    borderWidth: borders.line
                }
            ]}
        />
        <Image
            source={Linear2}
            style={[
                stylesheet.linear,
                {
                    borderRadius: radiuses.xl
                }
            ]}
        />
        <View
            style={[
                stylesheet.arrowContainer,
                {
                    borderRadius: radiuses.sm,
                    padding: spaces.spacingSm,
                    right: spaces.spacingXl,
                    top: spaces.spacingXl
                }
            ]}
        >
            <ArrowUpRight
                color={colors.project.gold}
                size={24}
            />
        </View>
        <View
            style={[
                stylesheet.content,
                {
                    paddingHorizontal: spaces.spacingXl,
                    bottom: spaces.spacingXl
                }
            ]}
        >
            <Text
                color="onPrimary"
                variant="headlineSmallSize"
                style={{
                    paddingBottom: spaces.spacingSm
                }}
            >
                {title}
            </Text>
            <Text
                color="onPrimary"
                variant="bodyMediumSize"
            >
                {content.length > 50
                    ? `${content.substring(0, 100)}..`
                    : content}
            </Text>
        </View>
    </TouchableOpacity>;
};
export default AnnouncementCard;
